import React, { Fragment, useState } from "react"
import { useTranslation } from "react-i18next"
import { FaTimes } from "react-icons/fa"
import isEmpty from "validator/lib/isEmpty"
import isMobilePhone from "validator/lib/isMobilePhone"

import { Button, KeyPads, Modal, TextField } from "components"
import classes from "./index.module.scss"
import KccmmPrompt from "./KccmmPrompt"

const KcCustomerMobileModal = props => {
  const {
    onSkip,
    openModal,
    setOpenModal,
    onMobilePhoneEnter
  } = props

  const [t] = useTranslation()

  const [error, setError] = useState("")
  const [openPromtModal, setOpenPromtModal] = useState(false)
  const [customerMobilePhone, setCustomerMobilePhone] = useState("")

  const handleExited = () => {
    setError("")

    setCustomerMobilePhone("")
  }

  const validate = () => {
    let result = true

    if (isEmpty(customerMobilePhone)) {
      result = false

      setError(t("شماره_موبایل_صحیح_نیست"))
    } else if (!isMobilePhone(`+98${customerMobilePhone.substring(1)}`, ["fa-IR"], { strictMode: true, })) {
      result = false

      setError(t("شماره_موبایل_صحیح_نیست"))
    }

    return result
  }

  const handleSaveMobile = () => {
    if (!validate()) return

    onMobilePhoneEnter(
      `+98${customerMobilePhone.substring(1)}`
    )

    setOpenModal(false)
  }

  return (
    <Fragment>
      <Modal
        show={openModal}
        onExited={handleExited}
        onHide={() => setOpenModal(false)}
      >
        <div className={classes["container"]}>
          <div className={classes["header"]}>
            <button
              className={classes["close"]}
              onClick={() => setOpenModal(false)}
            >
              <FaTimes size={20} />
            </button>
          </div>

          <h2 className={classes["title"]}>
            {t("جهت_اطلاع_از_وضعیت_سفارش_خود_شماره_موبایل_خود_را_وارد_کنید")}.
          </h2>

          <TextField
            type="text"
            readOnly
            placeholder={t("شماره_موبایل_خود_را_وارد_کنید")}
            value={customerMobilePhone}
            className={classes["input"]}
            onChange={(e) => setCustomerMobilePhone(e.target.value)}
          />

          <div className={classes["keypads"]}>
            <KeyPads
              type="text"
              value={customerMobilePhone}
              onChange={text => setCustomerMobilePhone(text)}
            />
          </div>

          {
            !!error &&
            <div className={classes["error"]}>
              * {error}
            </div>
          }

          <Button
            onClick={handleSaveMobile}
            color="success"
            fullWidth
          >
            {t("ثبت_شماره_موبایل")}
          </Button>

          <Button
            onClick={() => setOpenPromtModal(true)}
            className={classes["button"]}
            color="warning"
            fullWidth
          >
            {t("تمایل ندارم")}
          </Button>
        </div>
      </Modal>

      <KccmmPrompt
        onSkip={onSkip}
        setOpenModal={setOpenModal}
        openPromtModal={openPromtModal}
        setOpenPromtModal={setOpenPromtModal}
      />
    </Fragment>
  )
}

export default KcCustomerMobileModal